import { render, staticRenderFns } from "./SalesRecapNew_Details2.vue?vue&type=template&id=d6ebc9cc&"
import script from "./SalesRecapNew_Details2.vue?vue&type=script&lang=js&"
export * from "./SalesRecapNew_Details2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports